import {Component, Input, Output, EventEmitter, ChangeDetectionStrategy, ChangeDetectorRef} from '@angular/core';
import {ApiService} from '../shared/api.service';
import {NotificationService} from '../shared/notification.service';
import {Subscription} from 'rxjs';
import {NgxLinkifyjsService} from 'ngx-linkifyjs';
import {Utils} from '../utils';

@Component({
    selector: 'notes-component',
    templateUrl: 'notes.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class NotesComponent {
    comments = [];
    commentSubscription: Subscription;
    float = 'auto';
    loadCommentsSubscription: Subscription;
    user;
    notesComponentInput = this.utils.rand();
    newCommentHTML = '';

    @Input() assignment;
    @Input() reference;
    @Input() id;
    @Input() placeholder;
    @Output() commentsChange = new EventEmitter();

    constructor(public linkService: NgxLinkifyjsService , private cdr: ChangeDetectorRef, private api: ApiService, private notifyService: NotificationService, private utils: Utils) {
        this.user = api.getProp('user');
    }
    ngAfterViewInit() {
        this.setPlaceholder();
        this.loadComments();
        this.cdr.markForCheck();
    }
    addComment() {
        if( !this.newCommentHTML || this.newCommentHTML === '<p></p>' ) {
            return;
        }
        let user = this.user;
        let id = this.id;
        let date = new Date().toISOString();
        let reference = this.reference || '';
        let comment = {
            author: user.id,
            abbreviation: user.abbreviation,
            role: user.role,
            content: this.newCommentHTML,
            text: this.newCommentHTML,
            date: date,
            post: id,
            reference: reference
        };
        this.comments.unshift(comment);
        this.commentsChange.emit(this.comments);
        this.newCommentHTML = '';
        
        if( id ) {
            this.commentSubscription = this.api.doAction('post', 'comment', {
                action: 'create',
                comment: comment
            }).subscribe(
                data => {
                    let { content } = comment;
                    this.notifyService.comment({
                        content: content.replace(/(<p>|<\/p>)/gmi, ' ')
                    }, this.assignment);
                }
            );
        }
    }
    setPlaceholder() {
        let placeholder = this.placeholder;
        if( !placeholder ) {
            this.placeholder = 'Notes';
        }
    }
    loadComments() {
        let id = this.id;
        if( id ) {
            this.loadCommentsSubscription = this.api.doAction('post', 'comment', {
                action: 'read',
                post: id,
                reference: this.reference
            }).subscribe(
                data => {
                    this.comments = data;
                    this.commentsChange.emit(this.comments);
                    if( this.comments.length > 0 ) {
                        this.float = 'always';
                    }
                    this.cdr.markForCheck();
                }
            );
        }
    }
    resetComments() {
        this.comments = [];
        this.cdr.markForCheck();
    }
    escapeRegex(string) {
        return string.replace(/[/\-\\^$*+?.()|[\]{}]/g, '\\$&');
    }
    linkifyHtml(htmlString) {
        const foundLinks = this.linkService.find(htmlString.replace(/<[^>]*>/g, ' '));
        foundLinks.forEach(link => {
            link.href = link.href.replace('http://', 'https://');
            htmlString = htmlString.replace(new RegExp('(?<!href=")(?<!\/\/)' + this.escapeRegex(link.value) + '(?!<\/a)', 'm'), `<a target="_blank" href="${link.href}">${link.value}</a>`);
        });
        return htmlString;
    }
    ngOnDestroy() {
        if( this.loadCommentsSubscription ) {
            this.loadCommentsSubscription.unsubscribe();
        }        
        if( this.commentSubscription ) {
            this.commentSubscription.unsubscribe();
        }
    }
}